var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c("router-link", { attrs: { to: { name: "Home" } } }, [
                _vm._v("Accueil"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "breadcrumb-item active",
              attrs: { "aria-current": "page" },
            },
            [_vm._v("\n        Connecteur TITAN\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("connector-infos", {
        attrs: { "cnt-id": _vm.cntId, establishments: _vm.establishments },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("label.select_exist_esta"),
                    "label-cols-sm": "4",
                    "label-align-sm": "left",
                    "label-size": "sm",
                    "label-for": "filterInput",
                  },
                },
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          list: "list_esta",
                          id: "filterInput",
                          type: "search",
                          placeholder: _vm.$t("placeholder.find_esta"),
                        },
                        on: { change: _vm.filterChange },
                        model: {
                          value: _vm.filter,
                          callback: function ($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-datalist", {
                        attrs: {
                          id: "list_esta",
                          options: _vm.filtered,
                          "value-field": "value",
                          "text-field": "text",
                          selectable: "",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c("b-input-group-text", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.selectedEstablishment?.value)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: !_vm.selectedEstablishment },
                              on: {
                                click: function ($event) {
                                  _vm.filter = ""
                                  _vm.selectedEstablishment = null
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("btn.erase")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.LabelEstaSelected))]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.HasSelected
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("connector.label.apikey"),
                        "label-size": "sm",
                        "label-cols-sm": "3",
                        "label-align-sm": "left",
                        "label-for": "ApiKey",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "apikey",
                              state: _vm.goodApiKey,
                              placeholder: _vm.$t("placeholder.connector_key"),
                            },
                            on: { change: _vm.checkKeyUrl },
                            model: {
                              value: _vm.config.apikey,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "apikey", $$v)
                              },
                              expression: "config.apikey",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.goodApiKey } },
                            [
                              _vm._v(
                                "\n              Clé API transmise par Titan obligatoire.\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("placeholder.connector_login"),
                        "label-size": "sm",
                        "label-cols-sm": "3",
                        "label-align-sm": "left",
                        "label-for": "ApiKey",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "apilogin",
                              state: _vm.goodLoginKey,
                              placeholder: _vm.$t(
                                "placeholder.connector_login"
                              ),
                            },
                            on: { change: _vm.checkKeyUrl },
                            model: {
                              value: _vm.config.apilogin,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "apilogin", $$v)
                              },
                              expression: "config.apilogin",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.goodLoginKey } },
                            [
                              _vm._v(
                                "\n              Login transmise par Titan obligatoire.\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("placeholder.connector_password"),
                        "label-size": "sm",
                        "label-cols-sm": "3",
                        "label-align-sm": "left",
                        "label-for": "ApiKey",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "apipassword",
                              state: _vm.goodPasswordKey,
                              placeholder: _vm.$t(
                                "placeholder.connector_password"
                              ),
                            },
                            on: { change: _vm.checkKeyUrl },
                            model: {
                              value: _vm.config.apipassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "apipassword", $$v)
                              },
                              expression: "config.apipassword",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.goodPasswordKey } },
                            [
                              _vm._v(
                                "\n              Mot de passe transmise par Titan obligatoire.\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("connector.label.site_client"),
                        "label-size": "sm",
                        "label-cols-sm": "3",
                        "label-align-sm": "left",
                        "label-for": "Url",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "Url",
                              state: _vm.goodUrl,
                              placeholder: _vm.$t("placeholder.connector_url"),
                            },
                            on: { change: _vm.checkKeyUrl },
                            model: {
                              value: _vm.config.apiurl,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "apiurl", $$v)
                              },
                              expression: "config.apiurl",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: !!_vm.config.apiurl } },
                            [
                              _vm._v(
                                "\n              Racine du site client pour l'API obligatoire ET doit se terminé par un '/'.\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("connector.label.ext_id"),
                        "label-size": "sm",
                        "label-cols-sm": "3",
                        "label-align-sm": "left",
                        "label-for": "Url",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "ext_uri",
                              type: "number",
                              state: _vm.goodID,
                              placeholder: _vm.$t(
                                "placeholder.connector_ext_id"
                              ),
                            },
                            on: { change: _vm.checkKeyUrl },
                            model: {
                              value: _vm.config.ext_uri,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "ext_uri", $$v)
                              },
                              expression: "config.ext_uri",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: !!_vm.config.ext_uri } },
                            [
                              _vm._v(
                                "\n              ID de l'établissement envoyé par Titan.\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        disabled: !_vm.ApiKeyValid,
                        variant: _vm.ApiKeyValid
                          ? "outline-secondary"
                          : "warning",
                      },
                      on: { click: _vm.onTestApiKey },
                    },
                    [_vm._v(_vm._s(_vm.$t("connector.btn.test_api")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.HasSelected && _vm.HasConnectorTitanSelected
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        "border-variant": "secondary",
                        header: _vm.$t("connector.label.consistency"),
                        "header-border-variant": "secondary",
                        align: "center",
                      },
                    },
                    [
                      _c(
                        "b-card-text",
                        [
                          _c("connector-consistency", {
                            attrs: {
                              esta: _vm.selectedEstablishment?.value,
                              cnt: _vm.cntId,
                              config: _vm.config,
                              connector: "TITAN",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    {
                      attrs: { pills: "", card: "", vertical: "" },
                      model: {
                        value: _vm.connectorSelected,
                        callback: function ($$v) {
                          _vm.connectorSelected = $$v
                        },
                        expression: "connectorSelected",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        {
                          directives: [
                            { name: "b-tooltip", rawName: "v-b-tooltip" },
                          ],
                          attrs: { title: "admin" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fas", "sync-alt"] },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1283785437
                          ),
                        },
                        [
                          _vm._v(" "),
                          [
                            _c(
                              "b-container",
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "w-100 border-top border-bottom border-dark align-items-center",
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "text-info mb-3 font-italic",
                                        attrs: { sm: "8" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Activer le connecteur pour l'établissement\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "2" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              size: "sm",
                                              label: _vm.$t(
                                                "connector.label.enable"
                                              ),
                                              "label-size": "sm",
                                              "label-cols-sm": "1",
                                              "label-align-sm": "left",
                                              "label-for": "Actif",
                                            },
                                          },
                                          [
                                            _c("b-form-checkbox", {
                                              attrs: {
                                                id: "Actif",
                                                disabled: !_vm.ApiKeyValid,
                                                switch: "",
                                                size: "md",
                                                variant: "success",
                                              },
                                              model: {
                                                value: _vm.config.enable,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.config,
                                                    "enable",
                                                    $$v
                                                  )
                                                },
                                                expression: "config.enable",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "1" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              variant: "success",
                                              disabled:
                                                !_vm.saveEnabled ||
                                                !_vm.haveActivitiesConf ||
                                                !_vm.goodForm,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.SaveTITAN()
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btn.save")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", [
                                      _c("h6", [
                                        _vm._v("Paramètres nécessaires "),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Afin de pouvoir configurer le connecteur pour l'établissement, veuillez vérifier que les activités ci-dessous soient bien mappé avec ceux de Titan:"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("b-table", {
                                          attrs: {
                                            small: "",
                                            responsive: "sm",
                                            fields: _vm.fieldsRefs,
                                            items: [
                                              _vm.getAnisenActivityConf,
                                              _vm.getRefusConf,
                                              _vm.getLieuRefConf,
                                            ],
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(exturi)",
                                                fn: function (row) {
                                                  return [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        row.item.name ===
                                                        "Refus"
                                                          ? _c(
                                                              "b-form-select",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.notations,
                                                                },
                                                                model: {
                                                                  value:
                                                                    row.item
                                                                      .exturi,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        row.item,
                                                                        "exturi",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "row.item.exturi",
                                                                },
                                                              }
                                                            )
                                                          : row.item?.name ===
                                                            "LieuRef"
                                                          ? _c(
                                                              "b-form-select",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.places,
                                                                },
                                                                model: {
                                                                  value:
                                                                    row.item
                                                                      .exturi,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        row.item,
                                                                        "exturi",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "row.item.exturi",
                                                                },
                                                              }
                                                            )
                                                          : _c("b-form-input", {
                                                              attrs: {
                                                                disabled: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  row.item
                                                                    .exturi,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      row.item,
                                                                      "exturi",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "row.item.exturi",
                                                              },
                                                            }),
                                                        _vm._v(" "),
                                                        row.item.exturi ===
                                                          null &&
                                                        row.item.name !==
                                                          "Activity"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Veuillez spécifier cette valeur"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        row.item.exturi ===
                                                          null &&
                                                        row.item.name ===
                                                          "Activity"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Impossible de créer/trouver une activité ANISEN, veuillez contacter le BED."
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            4276615347
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tabs",
                              {
                                attrs: {
                                  "content-class": "mt-3",
                                  pills: "",
                                  card: "",
                                  justified: "",
                                  "active-nav-item-class":
                                    "font-weight-bold text-uppercase text-white bg-dark",
                                },
                              },
                              [
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "connector.label.parameters"
                                      ),
                                      active: "",
                                      disabled: !_vm.HasConnectorTitanSelected,
                                      "title-link-class":
                                        "text-white bg-secondary",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "connector.label.push_activities"
                                                  ),
                                                  "label-size": "sm",
                                                  "label-cols-sm": "6",
                                                  "label-align-sm": "left",
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c(
                                                          "b-form-checkbox",
                                                          {
                                                            attrs: {
                                                              switch: "",
                                                              size: "md",
                                                              variant:
                                                                "success",
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                !$event
                                                                  ? (_vm.config.enable_push_patgames = false)
                                                                  : null
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.config
                                                                  .enable_push_activity,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.config,
                                                                    "enable_push_activity",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "config.enable_push_activity",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "connector.label.enable"
                                                                  )
                                                                ) +
                                                                "\n                          "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c(
                                                          "b-form-checkbox",
                                                          {
                                                            attrs: {
                                                              switch: "",
                                                              size: "md",
                                                              variant:
                                                                "success",
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                $event
                                                                  ? (_vm.config.enable_push_activity = true)
                                                                  : null
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.config
                                                                  .enable_push_patgames,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.config,
                                                                    "enable_push_patgames",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "config.enable_push_patgames",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "connector.label.enable_patgames"
                                                                  )
                                                                ) +
                                                                "\n                          "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-container",
                                              { staticClass: "full-container" },
                                              [
                                                _c(
                                                  "b-card-group",
                                                  { attrs: { deck: "" } },
                                                  [
                                                    _c(
                                                      "b-card",
                                                      {
                                                        attrs: {
                                                          "border-variant":
                                                            "secondary",
                                                          header: _vm.$t(
                                                            "connector.label.list_job"
                                                          ),
                                                          "header-border-variant":
                                                            "secondary",
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-card-text",
                                                          [
                                                            _c("list-jobs", {
                                                              attrs: {
                                                                mappedMetiers:
                                                                  _vm.config
                                                                    .metiers,
                                                                sourceMetiers:
                                                                  _vm.metiers,
                                                                config:
                                                                  _vm.config,
                                                                connector:
                                                                  "TITAN",
                                                              },
                                                              on: {
                                                                "update-metier":
                                                                  _vm.updateMetier,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-container",
                                              { staticClass: "full-container" },
                                              [
                                                _c(
                                                  "b-card-group",
                                                  { attrs: { deck: "" } },
                                                  [
                                                    _c(
                                                      "b-card",
                                                      {
                                                        attrs: {
                                                          "border-variant":
                                                            "secondary",
                                                          header: _vm.$t(
                                                            "connector.label.list_filter_job"
                                                          ),
                                                          "header-border-variant":
                                                            "secondary",
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-card-text",
                                                          [
                                                            _c("filter-jobs", {
                                                              attrs: {
                                                                jobs: _vm.filterJobs,
                                                              },
                                                              on: {
                                                                "update-filter-job":
                                                                  _vm.updateFilterJob,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: _vm.$t("connector.label.mapping"),
                                      disabled: !_vm.HasConnectorTitanSelected,
                                      "title-link-class":
                                        "text-white bg-secondary",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-container",
                                              { staticClass: "full-container" },
                                              [
                                                _c(
                                                  "b-card-group",
                                                  { attrs: { deck: "" } },
                                                  [
                                                    _c(
                                                      "b-card",
                                                      {
                                                        attrs: {
                                                          "border-variant":
                                                            "secondary",
                                                          header: _vm.$t(
                                                            "connector.label.list_service"
                                                          ),
                                                          "header-border-variant":
                                                            "secondary",
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-card-text",
                                                          [
                                                            _c(
                                                              "list-services",
                                                              {
                                                                attrs: {
                                                                  type: _vm
                                                                    .config
                                                                    .service
                                                                    .source,
                                                                  keyapi:
                                                                    _vm.config
                                                                      .apikey,
                                                                  urlapi:
                                                                    _vm.config
                                                                      .apiurl,
                                                                  esta: _vm
                                                                    .selectedEstablishment
                                                                    ?.value,
                                                                  cnt: _vm
                                                                    .TITANConnector
                                                                    ?.id,
                                                                  config:
                                                                    _vm.config,
                                                                  connector:
                                                                    "TITAN",
                                                                  ctx: _vm
                                                                    .config.ctx,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-container",
                                              { staticClass: "full-container" },
                                              [
                                                _c(
                                                  "b-card-group",
                                                  { attrs: { deck: "" } },
                                                  [
                                                    _c(
                                                      "b-card",
                                                      {
                                                        attrs: {
                                                          "border-variant":
                                                            "secondary",
                                                          header: _vm.$t(
                                                            "connector.label.list_place"
                                                          ),
                                                          "header-border-variant":
                                                            "secondary",
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-card-text",
                                                          [
                                                            _c("list-lieux", {
                                                              attrs: {
                                                                config:
                                                                  _vm.config,
                                                                connector:
                                                                  "TITAN",
                                                                esta: _vm
                                                                  .selectedEstablishment
                                                                  ?.value,
                                                                cnt: _vm
                                                                  .TITANConnector
                                                                  ?.id,
                                                                ctx: _vm.config
                                                                  .ctx,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-container",
                                              { staticClass: "full-container" },
                                              [
                                                _c(
                                                  "b-card-group",
                                                  { attrs: { deck: "" } },
                                                  [
                                                    _c(
                                                      "b-card",
                                                      {
                                                        attrs: {
                                                          "border-variant":
                                                            "secondary",
                                                          header: _vm.$t(
                                                            "connector.label.list_resident"
                                                          ),
                                                          "header-border-variant":
                                                            "secondary",
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-card-text",
                                                          [
                                                            _c(
                                                              "list-residents",
                                                              {
                                                                attrs: {
                                                                  esta: _vm
                                                                    .selectedEstablishment
                                                                    ?.value,
                                                                  cnt: _vm
                                                                    .TITANConnector
                                                                    ?.id,
                                                                  config:
                                                                    _vm.config,
                                                                  connector:
                                                                    "TITAN",
                                                                  ctx: _vm
                                                                    .config.ctx,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-container",
                                              { staticClass: "full-container" },
                                              [
                                                _c(
                                                  "b-card-group",
                                                  { attrs: { deck: "" } },
                                                  [
                                                    _c(
                                                      "b-card",
                                                      {
                                                        attrs: {
                                                          "border-variant":
                                                            "secondary",
                                                          header: _vm.$t(
                                                            "connector.label.list_personnel"
                                                          ),
                                                          "header-border-variant":
                                                            "secondary",
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-card-text",
                                                          [
                                                            _c(
                                                              "list-personnels",
                                                              {
                                                                attrs: {
                                                                  esta: _vm
                                                                    .selectedEstablishment
                                                                    ?.value,
                                                                  cnt: _vm
                                                                    .TITANConnector
                                                                    ?.id,
                                                                  config:
                                                                    _vm.config,
                                                                  connector:
                                                                    "TITAN",
                                                                  ctx: _vm
                                                                    .config.ctx,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          directives: [
                            { name: "b-tooltip", rawName: "v-b-tooltip" },
                          ],
                          attrs: { title: "push" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fas", "sign-in-alt"] },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            900080579
                          ),
                        },
                        [
                          _vm._v(" "),
                          [
                            _c(
                              "b-container",
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "w-100 border-top border-bottom border-dark align-items-center",
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "text-info mb-3 font-italic",
                                        attrs: { sm: "8" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Activer le connecteur pour l'établissement\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "2" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              size: "sm",
                                              label: _vm.$t(
                                                "connector.label.enable"
                                              ),
                                              "label-size": "sm",
                                              "label-cols-sm": "1",
                                              "label-align-sm": "left",
                                              "label-for": "pActif",
                                            },
                                          },
                                          [
                                            _c("b-form-checkbox", {
                                              attrs: {
                                                id: "pActif",
                                                disabled: !_vm.ApiKeyValid,
                                                switch: "",
                                                size: "md",
                                                variant: "success",
                                              },
                                              model: {
                                                value: _vm.config.enable,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.config,
                                                    "enable",
                                                    $$v
                                                  )
                                                },
                                                expression: "config.enable",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "1" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              variant: "success",
                                              disabled:
                                                !_vm.saveEnabled ||
                                                !_vm.haveActivitiesConf ||
                                                !_vm.goodForm,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.SaveTITAN()
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btn.save")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", [
                                      _c("h6", [
                                        _vm._v("Paramètres nécessaires "),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Afin de pouvoir configurer le connecteur pour l'établissement, veuillez vérifier que les activités ci-dessous soient bien liées avec ceux de Titan :"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("b-table", {
                                          attrs: {
                                            small: "",
                                            responsive: "sm",
                                            fields: _vm.fieldsRefs,
                                            items: [
                                              _vm.getAnisenActivityConf,
                                              _vm.getRefusConf,
                                              _vm.getLieuRefConf,
                                            ],
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(exturi)",
                                                fn: function (row) {
                                                  return [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        row.item.name ===
                                                        "Refus"
                                                          ? _c(
                                                              "b-form-select",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.notations,
                                                                },
                                                                model: {
                                                                  value:
                                                                    row.item
                                                                      .exturi,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        row.item,
                                                                        "exturi",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "row.item.exturi",
                                                                },
                                                              }
                                                            )
                                                          : row.item?.name ===
                                                            "LieuRef"
                                                          ? _c(
                                                              "b-form-select",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.places,
                                                                },
                                                                model: {
                                                                  value:
                                                                    row.item
                                                                      .exturi,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        row.item,
                                                                        "exturi",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "row.item.exturi",
                                                                },
                                                              }
                                                            )
                                                          : _c("b-form-input", {
                                                              attrs: {
                                                                disabled: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  row.item
                                                                    .exturi,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      row.item,
                                                                      "exturi",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "row.item.exturi",
                                                              },
                                                            }),
                                                        _vm._v(" "),
                                                        row.item.exturi ===
                                                          null &&
                                                        row.item.name !==
                                                          "Activity"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Veuillez spécifier cette valeur"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        row.item.exturi ===
                                                          null &&
                                                        row.item.name ===
                                                          "Activity"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Impossible de créer/trouver une activité ANISEN, veuillez contacter le BED."
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            4276615347
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-container",
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("b-col", { attrs: { sm: "5" } }, [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "connector.label.transmission"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { sm: "2" } }),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { sm: "5" } }, [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("connector.label.report")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "border-top",
                                        attrs: { sm: "5" },
                                      },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "connector.label.enable"
                                              ),
                                              "label-size": "sm",
                                              "label-cols-sm": "4",
                                              "label-align-sm": "left",
                                              "label-for": "tenable",
                                            },
                                          },
                                          [
                                            _c("b-form-checkbox", {
                                              attrs: {
                                                id: "tenable",
                                                switch: "",
                                                size: "md",
                                                variant: "success",
                                              },
                                              model: {
                                                value:
                                                  _vm.config.push.trans.enable,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.config.push.trans,
                                                    "enable",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "config.push.trans.enable",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { sm: "2" } }),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "border-top",
                                        attrs: { sm: "5" },
                                      },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "connector.label.enable"
                                              ),
                                              "label-size": "sm",
                                              "label-cols-sm": "4",
                                              "label-align-sm": "left",
                                              "label-for": "renable",
                                            },
                                          },
                                          [
                                            _c("b-form-checkbox", {
                                              attrs: {
                                                id: "renable",
                                                switch: "",
                                                size: "md",
                                                variant: "success",
                                              },
                                              model: {
                                                value:
                                                  _vm.config.push.report.enable,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.config.push.report,
                                                    "enable",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "config.push.report.enable",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("modal-connector-error", {
        ref: "modalError",
        attrs: {
          "error-summary": _vm.$t("connector.error.titan_summary"),
          errors: _vm.detailedErrors,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }